import { FC } from "react";

const ArrowVector: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="121"
      height="64"
      viewBox="0 0 121 64"
      fill="none"
      className={className}
    >
      <path
        d="M1.1962 13.8184C0.954639 14.8668 -0.0563755 17.0014 0.923785 17.9017C2.24733 19.1173 3.23212 17.5888 3.87182 16.6129C5.12975 14.694 5.57554 11.1139 7.3796 9.73064C13.2219 26.6635 24.8616 41.0052 41.1719 50.7611C57.3946 60.4647 78.617 66.5097 97.2142 61.2456C106.317 58.6691 114.506 53.7919 119 45.8521C119.385 45.1709 121.464 41.8907 119.747 41.6484C118.852 41.5222 116.228 45.7594 115.629 46.4438C112.514 50.0017 108.883 52.8336 104.515 55.0038C89.6321 62.3985 70.5683 60.1889 55.2737 53.7981C45.142 49.5646 35.7289 43.1772 28.1306 35.5592C24.2085 31.6271 20.5978 27.2794 17.7876 22.608C15.4173 18.6679 11.3568 12.2657 11.4154 7.69085C15.4657 9.23003 18.1787 14.4176 21.9983 16.4969C24.0218 17.5986 26.7217 17.2014 25.7355 14.614C24.9361 12.5163 21.2711 10.4619 19.5047 9.02838C17.5337 7.42886 15.5201 5.89535 13.4028 4.46731C11.8497 3.41978 8.96629 0.59245 6.99986 0.84069C3.52273 1.27962 1.91058 11.1529 1.1962 13.8184C1.49426 12.7063 0.943654 14.9144 1.1962 13.8184Z"
        fill="#057C82"
      />
      <path
        d="M1.1962 13.8184C0.954639 14.8668 -0.0563755 17.0014 0.923785 17.9017C2.24733 19.1173 3.23212 17.5888 3.87182 16.6129C5.12975 14.694 5.57554 11.1139 7.3796 9.73064C13.2219 26.6635 24.8616 41.0052 41.1719 50.7611C57.3946 60.4647 78.617 66.5097 97.2142 61.2456C106.317 58.6691 114.506 53.7919 119 45.8521C119.385 45.1709 121.464 41.8907 119.747 41.6484C118.852 41.5222 116.228 45.7594 115.629 46.4438C112.514 50.0017 108.883 52.8336 104.515 55.0038C89.6321 62.3985 70.5683 60.1889 55.2737 53.7981C45.142 49.5646 35.7289 43.1772 28.1306 35.5592C24.2085 31.6271 20.5978 27.2794 17.7876 22.608C15.4173 18.6679 11.3568 12.2657 11.4154 7.69085C15.4657 9.23003 18.1787 14.4176 21.9983 16.4969C24.0218 17.5986 26.7217 17.2014 25.7355 14.614C24.9361 12.5163 21.2711 10.4619 19.5047 9.02838C17.5337 7.42886 15.5201 5.89535 13.4028 4.46731C11.8497 3.41978 8.96629 0.59245 6.99986 0.84069C3.52273 1.27962 1.91058 11.1529 1.1962 13.8184C1.49426 12.7063 0.943654 14.9144 1.1962 13.8184Z"
        fill="url(#paint0_radial_438_25143)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_438_25143"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(95.6907 41.1462 -117.717 165.341 8.86003 9.05863)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#057176" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default ArrowVector;
